function parseDateParts(value: string | null | undefined) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || "").trim());
  if (!match) return null;

  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  };
}

function formatDate(year: number, month: number, day: number) {
  return [year, String(month).padStart(2, "0"), String(day).padStart(2, "0")].join(
    "-"
  );
}

export function addCalendarMonths(dateValue: string, months: number) {
  const parts = parseDateParts(dateValue);
  if (!parts || !Number.isFinite(months)) return "";

  const wholeMonths = Math.trunc(months);
  const targetMonthIndex = parts.month - 1 + wholeMonths;
  const targetYear = parts.year + Math.floor(targetMonthIndex / 12);
  const targetMonth = ((targetMonthIndex % 12) + 12) % 12;
  const daysInTargetMonth = new Date(
    targetYear,
    targetMonth + 1,
    0
  ).getDate();

  return formatDate(
    targetYear,
    targetMonth + 1,
    Math.min(parts.day, daysInTargetMonth)
  );
}

export function subtractCalendarDays(dateValue: string, days: number) {
  const parts = parseDateParts(dateValue);
  if (!parts || !Number.isFinite(days)) return "";

  const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  date.setUTCDate(date.getUTCDate() - Math.trunc(days));

  return formatDate(
    date.getUTCFullYear(),
    date.getUTCMonth() + 1,
    date.getUTCDate()
  );
}

export function calculateRenewalSchedule(
  subscriptionStart: string,
  termMonths: number
) {
  const renewalDate = addCalendarMonths(subscriptionStart, termMonths);
  if (!renewalDate) {
    return {
      renewalDate: "",
      renewalStartDate: "",
      renewalEndDate: "",
    };
  }

  return {
    renewalDate,
    renewalStartDate: renewalDate,
    renewalEndDate: addCalendarMonths(renewalDate, termMonths),
  };
}

export function inferRenewalTermMonths(
  subscriptionStart: string,
  renewalEndpoint: string,
  fallback = 3
) {
  if (!parseDateParts(subscriptionStart) || !parseDateParts(renewalEndpoint)) {
    return fallback;
  }

  for (let months = 1; months <= 120; months += 1) {
    if (addCalendarMonths(subscriptionStart, months) === renewalEndpoint) {
      return months;
    }
  }

  const start = parseDateParts(subscriptionStart);
  const endpoint = parseDateParts(renewalEndpoint);
  if (!start || !endpoint) return fallback;

  return Math.max(
    1,
    (endpoint.year - start.year) * 12 + endpoint.month - start.month
  );
}
